// Default rate unit applied when attaching a prescription. The unit string is
// metadata only at the wire level; the engine uses the `rate` numeric value
// directly. We default to gallons-per-acre because every shipped prototype
// shapefile expresses rate in that unit.
export const DEFAULT_RATE_UNIT = 'gal/ac';

// Default gap policy when the user hasn't picked one. Server treats null as
// MASK; we mirror that here so the UI default matches the wire default.
export const DEFAULT_GAP_POLICY = 'MASK' as const;

export const STATE_IDLE = 'idle';

export const STATE_PARSING = 'parsing';

export const STATE_COLUMN_SELECTION = 'columnSelection';

export const STATE_VALIDATING = 'validating';

export const STATE_REJECTED = 'rejected';
